export async function nativeLinkOpener(externalLink, target = '_blank', $event, windowFeatures, CapacitorBrowser) {
    if (CapacitorBrowser && target === '_blank') {
        $event === null || $event === void 0 ? void 0 : $event.preventDefault();
        await CapacitorBrowser.open({
            url: externalLink
        });
    }
    else if (target) {
        await navigateTo(externalLink, {
            external: true,
            open: {
                target,
                windowFeatures
            }
        });
    }
    else {
        await navigateTo(externalLink, { external: true });
    }
}
//# sourceMappingURL=nativeLinkOpener.js.map